import { r as registerInstance, h, F as Fragment, c as createEvent, g as getElement } from './index-1cb43162.js';

const getCookie = (name) => {
  let cookieArr = document.cookie.split(";");
  for (const cookie of cookieArr) {
    let cookiePair = cookie.split("=");
    if (name === cookiePair[0].trim()) {
      return cookiePair[1];
    }
  }
  return null;
};
const setCookie = (name, value, days) => {
  let cookie = name + "=" + value;
  if (days) {
    cookie += "; max-age=" + days * 24 * 60 * 60;
  }
  document.cookie = cookie;
};

const translations = {
  de: {
    countdown: {
      days: "Tage",
      day: "Tag",
      hours: "Stunden",
      hour: "Stunde",
      minutes: "Minuten",
      minute: "Minute",
      seconds: "Sekunden",
      second: "Sekunde"
    },
    newsletter: {
      buttons: {
        close: "Schließen",
        register: "Anmelden"
      },
      error: {
        message: {
          "1": "Bitte alle Pflichtfelder ausfüllen.",
          "2": "Datenschutzbestimmungen müssen akzeptiert werden.",
          "3": "Konto existiert bereits."
        }
      },
      placeholders: {
        firstname: "Vorname",
        lastname: "Nachname",
        email: "E-Mail"
      },
      privacy: {
        text01: "Ich akzeptiere die",
        text02: "Datenschutzbestimmungen"
      },
      success: {
        title: "Nur noch 1 Schritt",
        text01: "Bitte bestätigen Sie Ihre E-Mail-Adresse",
        text02: "Wir haben Ihnen dazu eine E-Mail mit einem Link geschickt. Nach Klick auf den Link erhalten Sie in Zukunft unseren Newsletter, den Sie jederzeit abbestellen können."
      }
    }
  },
  en: {
    countdown: {
      days: "Days",
      day: "Day",
      hours: "Hours",
      hour: "Hour",
      minutes: "Minutes",
      minute: "Minute",
      seconds: "Seconds",
      second: "Second"
    },
    newsletter: {
      buttons: {
        close: "Close",
        register: "Register"
      },
      error: {
        message: {
          "1": "Please fill in all required fields.",
          "2": "Data protection regulations must be accepted.",
          "3": "Account already exists."
        }
      },
      placeholders: {
        firstname: "Firstname",
        lastname: "Lastname",
        email: "Email"
      },
      privacy: {
        text01: "I accept the",
        text02: "Privacy policy"
      },
      success: {
        title: "Just 1 more step",
        text01: "Please confirm your email address",
        text02: "We have sent you an email with a link for this purpose. After clicking on the link, you will receive our newsletter in the future, which you can unsubscribe at any time."
      }
    }
  }
};

const getTranslations = (lang) => {
  var _a;
  let language = (_a = lang !== null && lang !== void 0 ? lang : document.querySelector("html").getAttribute("lang")) !== null && _a !== void 0 ? _a : "en";
  if (!translations[language]) {
    console.warn(`no translations for language: ${language}, loading default locale en`);
    return;
  }
  return translations[language];
};

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return _root.Date.now();
};

var now_1 = now;

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

var _trimmedEndIndex = trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, _trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

var _baseTrim = baseTrim;

/** Built-in value references. */
var Symbol = _root.Symbol;

var _Symbol = Symbol;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$2.toString;

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$1.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol_1(value)) {
    return NAN;
  }
  if (isObject_1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject_1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = _baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var toNumber_1 = toNumber;

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber_1(wait) || 0;
  if (isObject_1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$1(toNumber_1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now_1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now_1());
  }

  function debounced() {
    var time = now_1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce;

const MicadoIal = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.language = "de";
    this.pageId = "";
    this.path = "";
    this.showOnConsentAccepted = true;
    this.data = [];
    this.queues = {};
    this.tick = {};
    this.windowWidth = 0;
    this.fetchData = async () => {
      const response = await fetch(`${this.path}/interactionlayer.json.api?lang=${this.language}${this.pageId ? `&pageid=${this.pageId}` : ``}`);
      const fetchData = await response.json();
      return fetchData;
    };
  }
  async componentWillLoad() {
    this.show();
    document.body.addEventListener("mw-consent-accepted", () => {
      this.show();
    });
    document.body.addEventListener("mw-consent-customized", () => {
      this.show();
    });
    document.body.addEventListener("mw-consent-ignored", () => {
      this.show();
    });
  }
  filterByDevice(data, device) {
    return data.filter((item) => {
      return typeof device === "number"
        ? item.Device === device
        : device.includes(item.Device);
    });
  }
  getWindowWidth() {
    return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth);
  }
  setData() {
    let data = null;
    if (this.windowWidth < 768) {
      data = this.filterByDevice(this.data, [1, 3]);
    }
    else {
      data = this.filterByDevice(this.data, [1, 2]);
    }
    this.queues = this.setQueuesByPlacement(data);
  }
  setQueuesByPlacement(data) {
    let queues = {};
    data.forEach((item) => {
      const key = item === null || item === void 0 ? void 0 : item.Placement.toLocaleLowerCase();
      if (!queues[key]) {
        queues[key] = [];
      }
      queues[key].push(item);
    });
    return queues;
  }
  show() {
    if (this.showOnConsentAccepted && getCookie("mw-cookie-settings") === null) {
      return;
    }
    this.translation = getTranslations(this.language);
    this.windowWidth = this.getWindowWidth();
    window.addEventListener("resize", debounce_1(() => {
      this.windowWidth = this.getWindowWidth();
      this.setData();
    }, 100));
    async function load() {
      this.data = await this.fetchData();
      this.setData();
    }
    load.call(this);
  }
  dequeue(e) {
    const placement = e === null || e === void 0 ? void 0 : e.detail;
    this.queues[placement].shift();
    this.tick = {};
  }
  renderItem(item) {
    var _a, _b, _c;
    let headline = null;
    let text = null;
    let image = null;
    let addition = null;
    let addressGroup = null;
    let button = null;
    let buttonURL = null;
    let buttonURLRel = null;
    let buttonTarget = null;
    let option = null;
    let option2 = null;
    switch (item === null || item === void 0 ? void 0 : item.Type) {
      case "Message":
        headline = item.Title;
        text = item.Text;
        image = item.MediaFile;
        if (item.ActionType === "Redirect" || item.ActionType === "ExternalRedirect") {
          button = item.ActionTitle;
          buttonURL = item.ActionURL;
          buttonURLRel = item.ActionUrlRel;
          buttonTarget = item.ActionTarget;
        }
        return (h("micado-ial-item-message", { headline: headline, text: text, image: image, button: button, buttonURL: buttonURL, buttonURLRel: buttonURLRel, buttonTarget: buttonTarget, path: this.path }));
      case "Notification":
        headline = item.Title;
        if (item.ActionType === "Redirect" || item.ActionType === "ExternalRedirect") {
          button = item.ActionTitle;
          buttonURL = item.ActionURL;
          buttonURLRel = item.ActionUrlRel;
          buttonTarget = item.ActionTarget;
        }
        return (h("micado-ial-item-notification", { button: button, buttonTarget: buttonTarget, buttonURL: buttonURL, buttonURLRel: buttonURLRel, headline: headline }));
      case "Countdown":
        headline = item.Title;
        text = item.Text;
        image = item.MediaFile;
        if (item.ActionType === "Redirect" || item.ActionType === "ExternalRedirect") {
          button = item.ActionTitle;
          buttonURL = item.ActionURL;
          buttonURLRel = item.ActionUrlRel;
          buttonTarget = item.ActionTarget;
        }
        const countdownDate = item.OptionDate;
        return (h("micado-ial-item-countdown", { button: button, buttonTarget: buttonTarget, buttonURL: buttonURL, buttonURLRel: buttonURLRel, countdownDate: countdownDate, headline: headline, image: image, path: this.path, text: text, translation: (_a = this === null || this === void 0 ? void 0 : this.translation) === null || _a === void 0 ? void 0 : _a.countdown }));
      case "Offer":
        headline = item.Title;
        text = item.Text;
        image = item.MediaFile;
        addition = item.Addition;
        if (item.ActionType === "Redirect" || item.ActionType === "ExternalRedirect") {
          button = item.ActionTitle;
          buttonURL = item.ActionURL;
          buttonURLRel = item.ActionUrlRel;
          buttonTarget = item.ActionTarget;
        }
        return (h("micado-ial-item-offer", { addition: addition, button: button, buttonTarget: buttonTarget, buttonURL: buttonURL, buttonURLRel: buttonURLRel, headline: headline, image: image, path: this.path, text: text }));
      case "Image":
        headline = item.Title;
        image = item.MediaFile;
        if (item.ActionType === "Redirect" || item.ActionType === "ExternalRedirect") {
          button = item.ActionTitle;
          buttonURL = item.ActionURL;
          buttonURLRel = item.ActionUrlRel;
          buttonTarget = item.ActionTarget;
        }
        return (h("micado-ial-item-graphic", { button: button, buttonTarget: buttonTarget, buttonURL: buttonURL, buttonURLRel: buttonURLRel, headline: headline, image: image, path: this.path }));
      case "NewsletterRegistration":
        headline = item.Title;
        text = item.Text;
        image = item.MediaFile;
        addressGroup = item.AddressGroup;
        return (h("micado-ial-item-newsletter", { addressGroup: addressGroup, headline: headline, image: image, path: this.path, text: text, translation: (_b = this === null || this === void 0 ? void 0 : this.translation) === null || _b === void 0 ? void 0 : _b.newsletter }));
      case "CommunicationStart":
        headline = item.Title;
        text = item.Text;
        image = item.MediaFile;
        option = item.OptionStr;
        option2 = item.OptionStr2;
        return (h("micado-ial-item-contact", { headline: headline, image: image, option: option, option2: option2, path: this.path, text: text, translation: (_c = this === null || this === void 0 ? void 0 : this.translation) === null || _c === void 0 ? void 0 : _c.contact }));
    }
  }
  getShowBulletsByPosition(item) {
    return ["bottom", "top"].includes(item);
  }
  getShowNavByPosition(item) {
    return ["bottom", "top"].includes(item);
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    let result = [];
    for (const item in this.queues) {
      if (this.queues[item].length === 0) {
        continue;
      }
      const locals = (_a = this.queues[item][0]) === null || _a === void 0 ? void 0 : _a.Locals;
      const content = [];
      if (locals.length > 1) {
        let newItem = Object.assign({}, this.queues[item][0]);
        locals.forEach((item) => {
          content.push(h("div", { class: "micado-ial-slider__item" }, this.renderItem(Object.assign(Object.assign({}, newItem), item))));
        });
      }
      else {
        content.push(this.renderItem(this.queues[item][0]));
      }
      let slider = null;
      if (content.length > 1) {
        slider = (h("micado-ial-slider", { content: content, counter: content === null || content === void 0 ? void 0 : content.length, showBullets: !this.getShowBulletsByPosition(item), showNav: this.getShowNavByPosition(item) }));
      }
      result.push(h(Fragment, null, ((_b = this.queues[item][0]) === null || _b === void 0 ? void 0 : _b.Placement) === "Focus" ? (h("micado-ial-overlay", { key: (_c = this.queues[item][0]) === null || _c === void 0 ? void 0 : _c.ID, content: h("micado-ial-tracking", { key: (_d = this.queues[item][0]) === null || _d === void 0 ? void 0 : _d.ID, content: slider !== null && slider !== void 0 ? slider : content[0], identifier: (_e = this.queues[item][0]) === null || _e === void 0 ? void 0 : _e.ID, path: this.path }), data: this.queues[item][0], path: this.path })) : (h("micado-ial-wrapper", { key: (_f = this.queues[item][0]) === null || _f === void 0 ? void 0 : _f.ID, content: h("micado-ial-tracking", { key: (_g = this.queues[item][0]) === null || _g === void 0 ? void 0 : _g.ID, content: slider !== null && slider !== void 0 ? slider : content[0], identifier: (_h = this.queues[item][0]) === null || _h === void 0 ? void 0 : _h.ID, path: this.path }), data: this.queues[item][0], path: this.path, position: (_j = this.queues[item][0]) === null || _j === void 0 ? void 0 : _j.Placement.toLocaleLowerCase() }))));
    }
    return result;
  }
};

const micadoIalItemContactCss = ".micado-ial-item-contact{margin:0 auto;max-width:450px;padding:24px}.micado-ial-item-contact__image-wrapper{display:flex;margin:0 0 24px}.micado-ial-item-contact__image{border-radius:50%;display:block;margin:0 auto;width:140px}.micado-ial-item-contact__headline{font-size:1.375rem;font-weight:700;margin:0 0 16px;text-align:center}.micado-ial-item-contact__text{margin:0 0 24px;text-align:center}.micado-ial-item-contact__link{margin:0 0 8px}.micado-ial-item-contact__link:last-child{margin-bottom:0}.micado-ial-item-contact__link a{align-items:center;display:flex}.micado-ial-item-contact__link a .micado-svg-icon{align-items:center;background:var(--mco-palette-primary-main, var(--mw-color-primary, #21262d));border-radius:50%;display:flex;height:50px;justify-content:center;margin:0 16px 0 0;width:50px}.micado-ial-item-contact__link a .micado-svg-icon svg,.micado-ial-item-contact__link a .micado-svg-icon svg path{fill:#ffffff}";

const MicadoIalItemContact = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    const phonenumber = typeof this.option2 === "string" ? this.option2.replace(/\s/g, "") : "";
    return (h("div", { class: "micado-ial-item micado-ial-item-contact" }, this.image && (h("div", { class: "micado-ial-item-contact__image-wrapper" }, h("img", { class: "micado-ial-item-contact__image", src: this.path + this.image, alt: "", loading: "lazy" }))), h("div", { class: "micado-ial-item-contact__content" }, this.headline && (h("p", { class: "micado-ial-item-contact__headline", innerHTML: this.headline })), this.text && (h("div", { class: "micado-ial-item-contact__text", innerHTML: this.text })), this.option && (h("div", { class: "micado-ial-item-contact__link" }, h("a", { href: `mailto:${this.option}` }, h("micado-svg-icon", { src: "/img/icons/mail.svg" }), this.option))), phonenumber && (h("div", { class: "micado-ial-item-contact__link" }, h("a", { href: `tel:${phonenumber}` }, h("micado-svg-icon", { src: "/img/icons/phone.svg" }), phonenumber))))));
  }
};
MicadoIalItemContact.style = micadoIalItemContactCss;

const micadoIalItemCountdownCss = ".micado-ial-item-countdown{margin:0 auto;max-width:var(--mco-max-width, var(--mw-max-width, 1280px))}.micado-ial-item-countdown__image{display:block;width:100%}.micado-ial-item-countdown__content-wrapper{margin:0 auto;max-width:620px;padding:24px}.micado-ial-item-countdown__headline{font-size:1.375rem;font-weight:700;margin:0 0 16px 0}.micado-ial-item-countdown__buttons{display:flex;justify-content:center;margin:24px 0 0 0}.micado-ial-item-countdown__link{display:block;width:100%}.micado-ial-item-countdown__button{background:var(--mco-palette-primary-main, var(--mw-color-primary, #21262d));border:0;color:#ffffff;max-width:100% !important;width:100%}.micado-ial-item-countdown__countdown-wrapper{display:grid;grid-column-gap:10px;grid-template-columns:1fr 1fr 1fr;margin:24px auto;max-width:400px;user-select:none;-webkit-user-select:none}.micado-ial-item-countdown__box{align-items:center;border:1px solid rgba(0, 0, 0, 0.1);border-radius:3px;display:flex;flex:0 0 85px;flex-direction:column;height:95px;justify-content:center}.micado-ial-item-countdown__box-value{font-size:2rem;font-weight:700;min-height:45px}.micado-ial-item-countdown__box-label{font-size:0.75rem;text-transform:uppercase}.micado-ial-item-countdown__box--hidden{display:none}.micado-ial__bottom .micado-ial-item-countdown,.micado-ial__top .micado-ial-item-countdown{max-width:none}.micado-ial__bottom .micado-ial-item-countdown__content-wrapper,.micado-ial__top .micado-ial-item-countdown__content-wrapper{align-items:center;display:flex;justify-content:center;max-width:var(--mco-max-width, var(--mw-max-width, 1280px));min-height:60px;padding-bottom:12px;padding-left:var(--mco-spacing, var(--mw-padding-left, 16px));padding-right:var(--mco-spacing, var(--mw-padding-left, 16px));padding-top:12px}.micado-ial__bottom .micado-ial-item-countdown__headline,.micado-ial__top .micado-ial-item-countdown__headline{color:#ffffff;display:none;margin-bottom:0}.micado-ial__bottom .micado-ial-item-countdown__text,.micado-ial__top .micado-ial-item-countdown__text{display:none}.micado-ial__bottom .micado-ial-item-countdown__countdown-wrapper,.micado-ial__top .micado-ial-item-countdown__countdown-wrapper{margin:0;max-width:none}.micado-ial__bottom .micado-ial-item-countdown__button,.micado-ial__top .micado-ial-item-countdown__button{height:30px;flex:unset;height:50px;justify-content:space-around}.micado-ial__bottom .micado-ial-item-countdown__box,.micado-ial__top .micado-ial-item-countdown__box{border-color:transparent;height:36px}.micado-ial__bottom .micado-ial-item-countdown__box-value,.micado-ial__top .micado-ial-item-countdown__box-value{color:#ffffff;font-size:1.2rem;line-height:1;min-height:auto}.micado-ial__bottom .micado-ial-item-countdown__box-label,.micado-ial__top .micado-ial-item-countdown__box-label{color:#ffffff}@media all and (min-width: 600px){.micado-ial__bottom .micado-ial-item-countdown__content-wrapper,.micado-ial__top .micado-ial-item-countdown__content-wrapper{justify-content:space-between}.micado-ial__bottom .micado-ial-item-countdown__headline,.micado-ial__top .micado-ial-item-countdown__headline{display:block}.micado-ial-item-countdown__content-wrapper{padding:24px}.micado-ial-item-countdown__buttons{margin-top:40px}.micado-ial-item-countdown__countdown-wrapper{margin-top:40px}}";

const MicadoIalItemCountdown = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  componentWillLoad() {
    const now = new Date();
    const targetDate = new Date(this.countdownDate);
    if (this.isValidDate(targetDate)) {
      this.milliseconds = targetDate.getTime() - now.getTime();
      this.timer = setInterval(() => {
        this.milliseconds = this.milliseconds - 1000;
        if (this.milliseconds <= 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    }
  }
  isValidDate(targetDate) {
    return !isNaN(targetDate.getTime());
  }
  render() {
    return (h("div", { class: [
        "micado-ial-item",
        "micado-ial-item-countdown",
        this.layout === "slim" ? "micado-ial-item-countdown-slim" : ""
      ].join(" ") }, this.image && this.layout !== "slim" && (h("div", { class: "micado-ial-item-countdown__image-wrapper" }, h("img", { class: "micado-ial-item-countdown__image", src: this.path + this.image, alt: "", loading: "lazy" }))), h("div", { class: "micado-ial-item-countdown__content-wrapper" }, this.headline && (h("p", { class: "micado-ial-item-countdown__headline", innerHTML: this.headline })), this.text && (h("div", { class: "micado-ial-item-countdown__text", innerHTML: this.text })), this.countdown(), this.button && (h("div", { class: "micado-ial-item-countdown__buttons" }, h("a", { class: "micado-ial-item-countdown__link", href: this.buttonURL ? this.buttonURL : undefined, target: this.buttonTarget ? this.buttonTarget : undefined, rel: this.buttonURLRel ? this.buttonURLRel : undefined }, h("button", { class: "micado-ial__button micado-ial-item-countdown__button" }, this.layout === "slim" ? (h("micado-svg-icon", { src: "/img/icons/arrow-right.svg" })) : (this.button))))))));
  }
  countdown() {
    if (this.milliseconds <= 0 || !this.translation) {
      return h("div", null);
    }
    let days = Math.floor(this.milliseconds / (1000 * 60 * 60 * 24));
    let hours = Math.floor((this.milliseconds / (1000 * 60 * 60)) % 24);
    let minutes = Math.floor((this.milliseconds / (1000 * 60)) % 60);
    let seconds = Math.floor((this.milliseconds / 1000) % 60);
    function formatValue(value) {
      return value < 10 ? "0" + value.toString() : value.toString();
    }
    const { days: localDays, day: localDay, hours: localHours, hour: localHour, minutes: localMinutes, minute: localMinute, seconds: localSeconds, second: localSecond } = this.translation;
    return (h("div", { class: "micado-ial-item-countdown__countdown-wrapper" }, h("div", { class: [
        "micado-ial-item-countdown__box",
        days === 0 ? "micado-ial-item-countdown__box--hidden" : ""
      ].join(" ") }, h("p", { class: "micado-ial-item-countdown__box-value" }, formatValue(days)), h("p", { class: "micado-ial-item-countdown__box-label" }, days !== 1 ? localDays : localDay)), h("div", { class: "micado-ial-item-countdown__box" }, h("p", { class: "micado-ial-item-countdown__box-value" }, formatValue(hours)), h("p", { class: "micado-ial-item-countdown__box-label" }, hours !== 1 ? localHours : localHour)), h("div", { class: "micado-ial-item-countdown__box" }, h("p", { class: "micado-ial-item-countdown__box-value" }, formatValue(minutes)), h("p", { class: "micado-ial-item-countdown__box-label" }, minutes !== 1 ? localMinutes : localMinute)), h("div", { class: [
        "micado-ial-item-countdown__box",
        days > 0 ? "micado-ial-item-countdown__box--hidden" : ""
      ].join(" ") }, h("p", { class: "micado-ial-item-countdown__box-value" }, formatValue(seconds)), h("p", { class: "micado-ial-item-countdown__box-label" }, seconds !== 1 ? localSeconds : localSecond))));
  }
};
MicadoIalItemCountdown.style = micadoIalItemCountdownCss;

const micadoIalItemGraphicCss = ".micado-ial-item-graphic__link{display:grid;margin:0 auto;max-width:768px}.micado-ial-item-graphic__image-wrapper{grid-column:1/1;grid-row:1/1}.micado-ial-item-graphic__image{display:block;order:1;width:100%}.micado-ial-item-graphic__content-wrapper{align-items:center;color:#ffffff;display:flex;flex-direction:column;grid-column:1/1;grid-row:1/1;justify-content:center;order:2}.micado-ial-item-graphic__headline{font-size:2rem;font-weight:400;margin:0;text-transform:uppercase}.micado-ial-item-graphic__content-backdrop{background:var(--mco-palette-background-backdrop, var(--mw-color-fancybox-rgba, rgba(30, 30, 30, 0.8)));grid-column:1/1;grid-row:1/1;order:0}";

const MicadoIalItemGraphic = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h("div", { class: "micado-ial-item micado-ial-item-graphic" }, h("a", { class: "micado-ial-item-graphic__link", href: this.buttonURL ? this.buttonURL : undefined, target: this.buttonTarget ? this.buttonTarget : undefined, rel: this.buttonURLRel ? this.buttonURLRel : undefined }, this.image && (h("div", { class: "micado-ial-item-graphic__image-wrapper" }, h("img", { class: "micado-ial-item-graphic__image", src: this.path + this.image, alt: "", loading: "lazy" }))), this.headline && (h(Fragment, null, h("div", { class: "micado-ial-item-graphic__content-wrapper" }, h("p", { class: "micado-ial-item-graphic__headline", innerHTML: this.headline })), h("div", { class: "micado-ial-item-graphic__content-backdrop" }))))));
  }
};
MicadoIalItemGraphic.style = micadoIalItemGraphicCss;

const micadoIalItemMessageCss = ".micado-ial-item-message__image{display:block;height:300px;object-fit:cover;width:100%}.micado-ial-item-message__content{padding:24px}.micado-ial-item-message__headline{font-size:1.375rem;font-weight:700;margin:0 0 16px}.micado-ial-item-message__buttons{display:flex;justify-content:center;margin:24px 0 0 0}.micado-ial-item-message__button{background:var(--mco-palette-primary-main, var(--mw-color-primary, #21262d));border:0;color:#ffffff;max-width:100% !important;width:100%}";

const MicadoIalItemMessage = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h("div", { class: "micado-ial-item micado-ial-item-message" }, this.image && (h("div", { class: "micado-ial-item-message__image-wrapper" }, h("img", { class: "micado-ial-item-message__image", src: this.path + this.image, alt: "", loading: "lazy" }))), h("div", { class: "micado-ial-item-message__content" }, this.headline && (h("p", { class: "micado-ial-item-message__headline", innerHTML: this.headline })), this.text && (h("div", { class: "micado-ial-item-message__text", innerHTML: this.text })), this.button && (h("div", { class: "micado-ial-item-message__buttons" }, h("a", { class: "micado-ial__button micado-ial-item-message__button", href: this.buttonURL ? this.buttonURL : undefined, target: this.buttonTarget ? this.buttonTarget : undefined, rel: this.buttonURLRel ? this.buttonURLRel : undefined }, this.button))))));
  }
};
MicadoIalItemMessage.style = micadoIalItemMessageCss;

const micadoIalItemNewsletterCss = ".micado-ial-item-newsletter__image{display:block;height:300px;object-fit:cover;width:100%}.micado-ial-item-newsletter__content{padding:24px}.micado-ial-item-newsletter__headline{font-size:1.375rem;font-weight:700;margin:0 0 16px;text-align:center}.micado-ial-item-newsletter__text{margin:0 0 24px;text-align:center}.micado-ial-item-newsletter__text--bold{font-weight:700}.micado-ial-item-newsletter__text span{display:block}.micado-ial-item-newsletter__form{display:flex;flex-wrap:wrap;justify-content:space-between}.micado-ial-item-newsletter__form-button{display:flex;justify-content:center;margin:24px 0 0;width:100%}.micado-ial-item-newsletter__form-button button{background:var(--mco-palette-primary-main, var(--mw-color-primary, #21262d));border:0;color:#ffffff;max-width:100%;width:100%}.micado-ial-item-newsletter__form-row{flex:0 0 49%;margin:0 0 10px;position:relative}.micado-ial-item-newsletter__form-row--full-width{flex:1 1 100%}.micado-ial-item-newsletter__form-row input{background:none;border:1px solid var(--mco-palette-gray-200, var(--mw-color-gray, #cccccc));height:50px;padding:0 10px;width:100%}.micado-ial-item-newsletter__form-checkbox{align-items:center;cursor:pointer;display:flex;flex-wrap:wrap;min-height:30px;padding:0 0 0 40px;position:relative}.micado-ial-item-newsletter__form-checkbox::before{border:1px solid var(--mco-palette-gray-200, var(--mw-color-gray, #cccccc));content:\"\";display:block;height:30px;left:0;margin:0 7px 0 0;position:absolute;width:30px}.micado-ial-item-newsletter__form-checkbox input{bottom:0;height:1px !important;left:0;opacity:0;position:absolute;width:1px !important}.micado-ial-item-newsletter__form-checkbox input:checked{background:var(--mco-palette-primary-main, var(--mw-color-primary, #21262d))}.micado-ial-item-newsletter__form-checkbox input:checked+micado-svg-icon{opacity:1}.micado-ial-item-newsletter__form-checkbox micado-svg-icon{left:5px;opacity:0;position:absolute;top:5px}.micado-ial-item-newsletter__form-checkbox micado-svg-icon svg{width:20px}.micado-ial-item-newsletter__form-message{align-items:center;flex:1 1 100%;font-size:14px;min-height:50px;padding:10px;text-align:left}.micado-ial-item-newsletter__form-message--error{border:1px solid var(--mco-palette-error-main, var(--mw-color-error, #d50b0b));color:var(--mco-palette-error-main, var(--mw-color-error, #d50b0b));display:flex}";

const MicadoIalItemNewsletter = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.error = {
      state: 0,
      message: ""
    };
    this.success = false;
    if (!this.api) {
      this.api = `${this.path}/newsletter-registration.api`;
    }
    this.data = {
      firstname: "",
      lastname: "",
      email: "",
      newsletter: ""
    };
  }
  handleChange(key, event) {
    this.data[key] = event.target.value;
  }
  handleCheckboxChange(key, event) {
    const target = event.target;
    if (target.checked) {
      this.data[key] = target.value;
    }
    else {
      this.data[key] = "";
    }
  }
  async handleSubmit(event) {
    event.preventDefault();
    if (!this.addressGroup) {
      console.error("IAL -> newsletter: missing group selection. newsletter registration is not saved!");
      return;
    }
    const response = await this.submitNewsletterData();
    if (response.state !== 0) {
      this.error = {
        state: response.state,
        message: this.getErrorMessage(response.state)
      };
      return;
    }
    if (response.state === 0) {
      this.success = true;
    }
  }
  async submitNewsletterData() {
    const formData = new FormData();
    for (const item in this.data) {
      formData.append(item, this.data[item]);
    }
    const response = await fetch(this.api, {
      method: "POST",
      body: formData
    });
    const fetchData = await response.json();
    return fetchData;
  }
  getErrorMessage(state) {
    var _a, _b, _c, _d;
    if ((_b = (_a = this.translation) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.message[state]) {
      return (_d = (_c = this.translation) === null || _c === void 0 ? void 0 : _c.error) === null || _d === void 0 ? void 0 : _d.message[state];
    }
    return "";
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    return (h("div", { class: "micado-ial-item micado-ial-item-newsletter" }, h("div", { class: "micado-ial-item-newsletter__image-wrapper" }, this.image ? (h("img", { class: "micado-ial-item-newsletter__image", src: this.path + this.image, alt: "", loading: "lazy" })) : (``)), h("div", { class: "micado-ial-item-newsletter__content" }, this.success ? (h(Fragment, null, h("p", { class: "micado-ial-item-newsletter__headline" }, (_b = (_a = this.translation) === null || _a === void 0 ? void 0 : _a.success) === null || _b === void 0 ? void 0 : _b.title), h("p", { class: "micado-ial-item-newsletter__text micado-ial-item-newsletter__text--centered" }, h("span", null, (_d = (_c = this.translation) === null || _c === void 0 ? void 0 : _c.success) === null || _d === void 0 ? void 0 : _d.text01), h("span", { class: "micado-ial-item-newsletter__text--bold" }, (_e = this.data) === null || _e === void 0 ? void 0 : _e.email)), h("p", { class: "micado-ial-item-newsletter__text" }, (_g = (_f = this.translation) === null || _f === void 0 ? void 0 : _f.success) === null || _g === void 0 ? void 0 : _g.text02), h("div", { class: "micado-ial-item-newsletter__form-button" }, h("button", { class: "micado-ial__button" }, (_j = (_h = this.translation) === null || _h === void 0 ? void 0 : _h.buttons) === null || _j === void 0 ? void 0 : _j.close)))) : (h(Fragment, null, this.headline && (h("p", { class: "micado-ial-item-newsletter__headline" }, this.headline)), this.text && (h("div", { class: "micado-ial-item-newsletter__text", innerHTML: this.text })), h("form", { class: "micado-ial-item-newsletter__form", method: "POST", onSubmit: (event) => this.handleSubmit(event) }, h("div", { class: "micado-ial-item-newsletter__form-row" }, h("input", { type: "text", name: "firstname", placeholder: (_l = (_k = this.translation) === null || _k === void 0 ? void 0 : _k.placeholders) === null || _l === void 0 ? void 0 : _l.firstname, required: true, onChange: (event) => this.handleChange("firstname", event) })), h("div", { class: "micado-ial-item-newsletter__form-row" }, h("input", { type: "text", name: "lastname", placeholder: (_o = (_m = this.translation) === null || _m === void 0 ? void 0 : _m.placeholders) === null || _o === void 0 ? void 0 : _o.lastname, required: true, onChange: (event) => this.handleChange("lastname", event) })), h("div", { class: "micado-ial-item-newsletter__form-row micado-ial-item-newsletter__form-row--full-width" }, h("input", { type: "email", name: "email", placeholder: (_q = (_p = this.translation) === null || _p === void 0 ? void 0 : _p.placeholders) === null || _q === void 0 ? void 0 : _q.email, required: true, onChange: (event) => this.handleChange("email", event) })), h("div", { class: "micado-ial-item-newsletter__form-row micado-ial-item-newsletter__form-row--full-width" }, h("label", { htmlFor: "micado-ial-item-newsletter-cb", class: "micado-ial-item-newsletter__form-checkbox" }, h("input", { id: "micado-ial-item-newsletter-cb", type: "checkbox", name: "newsletter", required: true, onChange: (event) => this.handleCheckboxChange("newsletter", event) }), h("micado-svg-icon", { src: "/img/icons/check.svg" }), `${(_s = (_r = this.translation) === null || _r === void 0 ? void 0 : _r.privacy) === null || _s === void 0 ? void 0 : _s.text01}`, "\u00A0", h("a", { href: "#", target: "_blank" }, (_u = (_t = this.translation) === null || _t === void 0 ? void 0 : _t.privacy) === null || _u === void 0 ? void 0 : _u.text02))), ((_v = this.error) === null || _v === void 0 ? void 0 : _v.message) && (h("p", { class: "micado-ial-item-newsletter__form-message micado-ial-item-newsletter__form-message--error" }, (_w = this.error) === null || _w === void 0 ? void 0 : _w.message)), h("div", { class: "micado-ial-item-newsletter__form-button" }, h("button", { class: "micado-ial__button", type: "submit" }, (_y = (_x = this.translation) === null || _x === void 0 ? void 0 : _x.buttons) === null || _y === void 0 ? void 0 : _y.register))))))));
  }
};
MicadoIalItemNewsletter.style = micadoIalItemNewsletterCss;

const micadoIalItemNotificationCss = ".micado-ial-item-notification{align-items:center;display:flex;justify-content:space-between;min-height:60px;padding:12px 74px 12px 16px}.micado-ial-item-notification__headline{margin:0}.micado-ial-item-notification__button{background:var(--mco-palette-primary-main, var(--mw-color-primary, #21262d));border:0;color:#ffffff;display:none !important;margin:0 0 0 16px !important}.micado-ial-item-notification__button--is-icon{align-items:center !important;display:flex !important;height:32px !important;justify-content:center !important;padding:0 !important;min-width:32px !important}.micado-ial-item-notification__button--is-icon svg{fill:#ffffff;width:16px !important}.micado-ial-item-notification__button--is-icon svg path{fill:#ffffff}.micado-ial__bottom .micado-ial-item-notification,.micado-ial__top .micado-ial-item-notification{justify-content:center;padding-left:var(--mco-spacing, var(--mw-padding-left, 16px));padding-right:var(--mco-spacing, var(--mw-padding-right, 16px))}.micado-ial__bottom .micado-ial-item-notification__headline,.micado-ial__top .micado-ial-item-notification__headline{color:#ffffff}.micado-ial__bottom .micado-ial-item-notification__button,.micado-ial__top .micado-ial-item-notification__button{color:#ffffff}.micado-ial__bottom .micado-ial-item-notification__button--is-text,.micado-ial__top .micado-ial-item-notification__button--is-text{border-bottom:1px solid #ffffff;display:flex !important}.micado-ial__bottom .micado-ial-item-notification__button--is-icon,.micado-ial__top .micado-ial-item-notification__button--is-icon{display:none !important}";

const MicadoIalItemNotification = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h("div", { class: [
        "micado-ial-item",
        "micado-ial-item-notification",
        this.boxShadow && "micado-ial-item-notification__box-shadow"
      ].join(" ") }, this.headline && (h("p", { class: "micado-ial-item-notification__headline", innerHTML: this.headline })), this.button && (h(Fragment, null, h("a", { class: "micado-ial__button micado-ial-item-notification__button micado-ial-item-notification__button--is-text", href: this.buttonURL ? this.buttonURL : undefined, target: this.buttonTarget ? this.buttonTarget : undefined, rel: this.buttonURLRel ? this.buttonURLRel : undefined }, this.button), h("a", { class: "micado-ial__button micado-ial-item-notification__button micado-ial-item-notification__button--is-icon", href: this.buttonURL ? this.buttonURL : undefined, target: this.buttonTarget ? this.buttonTarget : undefined, rel: this.buttonURLRel ? this.buttonURLRel : undefined }, h("micado-svg-icon", { src: "/img/icons/arrow-right.svg" }))))));
  }
};
MicadoIalItemNotification.style = micadoIalItemNotificationCss;

const micadoIalItemOfferCss = ".micado-ial-item-offer{display:grid;margin:0 auto;max-width:768px}.micado-ial-item-offer__image{display:block;min-height:300px;object-fit:cover;order:1;width:100%}.micado-ial-item-offer__image-wrapper{grid-column:1/1;grid-row:1/1}.micado-ial-item-offer__content-wrapper{align-items:center;color:#ffffff;display:flex;flex-direction:column;grid-column:1/1;grid-row:1/1;justify-content:center;order:2;padding:20px}.micado-ial-item-offer__headline{font-size:2rem;font-weight:700;margin:0 0 16px;text-transform:uppercase}.micado-ial-item-offer__addition{font-size:3rem}.micado-ial-item-offer__text{font-weight:400;text-align:center}.micado-ial-item-offer__link{margin:24px 0 0}.micado-ial-item-offer__button{background:var(--mco-palette-primary-main, var(--mw-color-primary, #21262d));border:0;color:#ffffff;max-width:100% !important;width:100%}.micado-ial-item-offer__content-backdrop{background:var(--mco-palette-background-backdrop, var(--mw-color-fancybox-rgba, rgba(30, 30, 30, 0.8)));grid-column:1/1;grid-row:1/1;order:0}";

const MicadoIalItemOffer = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h("div", { class: "micado-ial-item micado-ial-item-offer" }, this.image && (h("div", { class: "micado-ial-item-offer__image-wrapper" }, h("img", { class: "micado-ial-item-offer__image", src: this.path + this.image, alt: "", loading: "lazy" }))), h("div", { class: "micado-ial-item-offer__content-wrapper" }, this.headline && (h("p", { class: "micado-ial-item-offer__headline", innerHTML: this.headline })), this.addition && (h("p", { class: "micado-ial-item-offer__addition", innerHTML: this.addition })), this.text && h("div", { class: "micado-ial-item-offer__text", innerHTML: this.text }), this.button && (h("a", { class: "micado-ial-item-offer__link", href: this.buttonURL ? this.buttonURL : undefined, target: this.buttonTarget ? this.buttonTarget : undefined, rel: this.buttonURLRel ? this.buttonURLRel : undefined }, h("button", { class: "micado-ial__button micado-ial-item-offer__button" }, this.button)))), h("div", { class: "micado-ial-item-offer__content-backdrop" })));
  }
};
MicadoIalItemOffer.style = micadoIalItemOfferCss;

const checkShowType = (id, showType) => {
  if (getCookie(`mw-ial-showtype-${id}`) !== showType) {
    return "";
  }
  return getCookie(`mw-ial-showtype-${id}`);
};
const setShowType = (id, showType, showInterval) => {
  switch (showType) {
    case "Once":
      setCookie(`mw-ial-showtype-${id}`, "Once", 365 * 5);
      break;
    case "PerSession":
      setCookie(`mw-ial-showtype-${id}`, "PerSession");
      break;
    case "Interval":
      setCookie(`mw-ial-showtype-${id}`, "Interval", showInterval);
      break;
  }
};

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return setTimeout(function() { func.apply(undefined, args); }, wait);
}

var _baseDelay = baseDelay;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

var identity_1 = identity;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

var _overRest = overRest;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

var defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty = defineProperty;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty ? identity_1 : function(func, string) {
  return _defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant_1(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

var _setToString = setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return _setToString(_overRest(func, start, identity_1), func + '');
}

var _baseRest = baseRest;

/**
 * Invokes `func` after `wait` milliseconds. Any additional arguments are
 * provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.delay(function(text) {
 *   console.log(text);
 * }, 1000, 'later');
 * // => Logs 'later' after one second.
 */
var delay = _baseRest(function(func, wait, args) {
  return _baseDelay(func, toNumber_1(wait) || 0, args);
});

var delay_1 = delay;

const checkPageDepth = (position, limit) => {
  let value = parseInt(getCookie(`mw-ial-${position}-depth`));
  if (value > 0) {
    value++;
    setCookie(`mw-ial-${position}-depth`, value);
  }
  else {
    setCookie(`mw-ial-${position}-depth`, 1);
  }
  if (value > limit) {
    return true;
  }
  return false;
};

const track = async (id, action, path) => {
  return new Promise((resolve, reject) => {
    fetch(`${path}/interactionlayertracking.api?action=${action}&id=${id}`).then((result) => {
      if (result.status === 200) {
        console.info(`tracked action: ${action} of IAL with id: ${id}`);
        resolve(true);
      }
      else {
        console.error(`couldn't track action: ${action} of IAL with id: ${id}`);
        reject();
      }
    }, () => reject());
  });
};

const micadoIalOverlayCss = ".micado-overlay{bottom:0;display:none;left:0;overflow:auto;padding:24px;position:fixed;right:0;top:0;z-index:99999}.micado-overlay__outer{margin:auto;max-width:600px;position:relative;width:100%;z-index:2}.micado-overlay__inner{background:var(--mco-palette-background-body, var(--mw-color-body-background, #ffffff));opacity:0;transform:translate(0, 100px);transition:var(--mco-transition, var(--mw-core-transition-overlay, all 500ms cubic-bezier(0.14, 1, 0.67, 0.99)))}.micado-overlay--show{display:flex}.micado-overlay--animate .micado-overlay__inner{opacity:1;transform:translate(0, 0)}.micado-overlay__background{background:var(--mco-palette-background-backdrop, var(--mw-color-fancybox-rgba, rgba(30, 30, 30, 0.8)));bottom:0;left:0;opacity:0;position:fixed;right:0;top:0;z-index:1}.micado-overlay--animate .micado-overlay__background{opacity:1}.micado-overlay__close{align-items:center;background:var(--mco-palette-background-body, var(--mw-color-body-background, #ffffff));border-radius:50%;cursor:pointer;display:flex;height:40px;justify-content:center;position:absolute;right:16px;top:16px;transition:background 300ms ease;width:40px;z-index:99999}.micado-overlay__close .micado-svg-icon svg{transition:fill 300ms ease;width:16px}.micado-overlay__close:hover{background:var(--mco-palette-primary-main, var(--mw-color-primary, #21262d))}.micado-overlay__close:hover .micado-svg-icon svg{fill:#ffffff}";

const MicadoIalOverlay = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.close = createEvent(this, "close", 7);
    this.content = null;
    this.delay = 0;
    this.data = [];
    this.animate = false;
    this.show = false;
    this._timer = null;
  }
  componentWillLoad() {
    this.init();
    this.el.addEventListener("intersect", (event) => {
      var _a;
      this.active = (_a = event === null || event === void 0 ? void 0 : event.detail) !== null && _a !== void 0 ? _a : 0;
    });
  }
  init() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    if (checkShowType((_a = this.data) === null || _a === void 0 ? void 0 : _a.ID, (_b = this.data) === null || _b === void 0 ? void 0 : _b.ShowType) !== "") {
      return;
    }
    switch ((_c = this.data) === null || _c === void 0 ? void 0 : _c.TriggerType) {
      case "PageDepth":
        if (checkPageDepth((_d = this.data) === null || _d === void 0 ? void 0 : _d.ID, (_e = this.data) === null || _e === void 0 ? void 0 : _e.TriggerOption)) {
          this.show = true;
          this._timer = delay_1(() => {
            this.animate = true;
            this.reRender();
          }, 100);
        }
        break;
      case "Scroll":
        const scrollTop = window.scrollY;
        document.addEventListener("scroll", debounce_1(() => {
          const scrollY = window.scrollY;
          if (scrollY - scrollTop > 200) {
            this.show = true;
            this._timer = delay_1(() => {
              this.animate = true;
              this.reRender();
            }, 100);
          }
        }, 100));
        break;
      case "Usertime":
        if (((_f = this.data) === null || _f === void 0 ? void 0 : _f.TriggerOption2) === 0) {
          this.data.TriggerOption2 = 0.05;
        }
        this._timer = delay_1(() => {
          this.show = true;
          this.clearTimer();
          this._timer = delay_1(() => {
            var _a, _b;
            this.animate = true;
            this.reRender();
            if (((_a = this.data) === null || _a === void 0 ? void 0 : _a.TriggerOption) > 0) {
              this.clearTimer();
              this._timer = delay_1(() => {
                this.handleClose();
              }, ((_b = this.data) === null || _b === void 0 ? void 0 : _b.TriggerOption) * 1000);
            }
          }, 100);
        }, ((_g = this.data) === null || _g === void 0 ? void 0 : _g.TriggerOption2) * 1000);
        break;
      case "Immediate":
        this.data.TriggerOption2 = 1;
        this._timer = delay_1(() => {
          this.show = true;
          this.clearTimer();
          this._timer = delay_1(() => {
            this.animate = true;
            this.reRender();
          }, 100);
        }, ((_h = this.data) === null || _h === void 0 ? void 0 : _h.TriggerOption2) * 1000);
        break;
      case "ExitIntention":
        document.addEventListener("mouseleave", () => {
          this.show = true;
          this._timer = delay_1(() => {
            this.animate = true;
            this.reRender();
          }, 100);
        });
        break;
    }
    {
      setShowType((_j = this.data) === null || _j === void 0 ? void 0 : _j.ID, (_k = this.data) === null || _k === void 0 ? void 0 : _k.ShowType, (_l = this.data) === null || _l === void 0 ? void 0 : _l.ShowInterval);
    }
  }
  reRender() {
    const slider = this.el.querySelector("micado-ial-slider");
    if (slider)
      slider.setSliderWidth();
  }
  handleClose() {
    if (this.active) {
      track(this.active, "close", this.path);
    }
    this.clearTimer();
    this.close.emit("focus");
  }
  clearTimer() {
    clearTimeout(this._timer);
    this._timer = null;
  }
  render() {
    return (h(Fragment, null, h("div", { class: [
        "micado-overlay",
        this.show ? "micado-overlay--show" : "",
        this.animate ? "micado-overlay--animate" : ""
      ].join(" ") }, h("div", { class: "micado-overlay__outer" }, h("div", { class: "micado-overlay__inner" }, this.content, h("div", { class: "micado-overlay__close", onClick: () => this.handleClose() }, h("micado-svg-icon", { src: "/img/icons/close.svg" })))), h("div", { class: "micado-overlay__background", onClick: () => this.handleClose() }))));
  }
  get el() { return getElement(this); }
};
MicadoIalOverlay.style = micadoIalOverlayCss;

const micadoIalSliderCss = ".micado-ial-slider{display:flex}.micado-ial-slider__overflow{flex:1;order:2;overflow:hidden}.micado-ial-slider__content{display:block;min-height:55px;transition:transform 0.25s ease 0s}.micado-ial-slider__content::after{clear:both;content:\"\";display:block}.micado-ial-slider__item{align-items:center;display:flex;float:left;justify-content:center;margin-top:0;max-width:none;transform:translate(0, 0);transition:none;width:100%}.micado-ial-slider__nav{align-items:center;cursor:pointer;display:flex;justify-content:center;width:56px}.micado-ial-slider__nav--prev{order:1}.micado-ial-slider__nav--next{order:3}.micado-ial-slider__nav .micado-svg-icon{align-items:center;display:flex;justify-content:center}.micado-ial-slider__pagination{align-items:center;bottom:-28px;display:flex;justify-content:center;padding:0 24px;position:absolute;width:100%}.micado-ial-slider__pagination-item{background:var(--mco-palette-gray-100, var(--mw-color-primary-opacity-high, #f2f2f2));border-radius:50%;cursor:pointer;height:12px;margin:0 4px;transition:var(--mco-transition, var(--mw-core-transition-overlay, all 500ms cubic-bezier(0.14, 1, 0.67, 0.99)));width:12px}.micado-ial-slider__pagination-item--active{background:var(--mco-palette-primary-main, var(--mw-color-primary, #21262d))}";

const MicadoIalSlider = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.content = null;
    this.counter = 0;
    this.showBullets = false;
    this.showNav = true;
    this.currentSlide = 1;
  }
  componentDidLoad() {
    this._children = Array.from(this._element.querySelectorAll(".micado-ial-slider__item"));
    this._container = this._element.querySelector(".micado-ial-slider__content");
    this.setSliderWidth();
    window.addEventListener("resize", debounce_1(() => {
      this.setSliderWidth();
    }, 100));
  }
  async setSliderWidth() {
    let maxWidth = this._element.querySelector(".micado-ial-slider__overflow").clientWidth;
    for (const element of this._children) {
      element.style.width = `${maxWidth}px`;
    }
    this._container.style.width = `${maxWidth * this.counter}px`;
  }
  handleNavigatePrevious() {
    if (this.currentSlide > 1) {
      this.currentSlide--;
    }
    else {
      this.currentSlide = this.counter;
    }
    this.slide();
  }
  handleNavigateNext() {
    if (this.currentSlide < this.counter) {
      this.currentSlide++;
    }
    else {
      this.currentSlide = 1;
    }
    this.slide();
  }
  moveTo(item) {
    this.currentSlide = item;
    this.slide();
  }
  slide() {
    this._container.style.transform =
      "translate(-" + this._children[0].clientWidth * (this.currentSlide - 1) + "px, 0)";
  }
  renderPagination() {
    let entries = [];
    for (let i = 0; i < this.counter; i++) {
      entries.push(i + 1);
    }
    return (h("div", { class: "micado-ial-slider__pagination" }, entries.map((item) => {
      return (h("div", { class: [
          "micado-ial-slider__pagination-item",
          this.currentSlide === item ? "micado-ial-slider__pagination-item--active" : ""
        ].join(" "), onClick: () => this.moveTo(item) }));
    })));
  }
  render() {
    return (h(Fragment, null, h("div", { class: "micado-ial-slider", ref: (el) => (this._element = el) }, h("div", { class: "micado-ial-slider__overflow" }, h("div", { class: "micado-ial-slider__content" }, this.content)), this.showNav && (h(Fragment, null, h("div", { class: [
        "micado-ial-slider__nav",
        "micado-ial-slider__nav--prev",
        this.currentSlide === 1 ? "micado-ial-slider__nav--disabled" : ""
      ].join(" "), onClick: () => this.handleNavigatePrevious() }, h("micado-svg-icon", { src: "/img/icons/arrow-left.svg" })), h("div", { class: [
        "micado-ial-slider__nav",
        "micado-ial-slider__nav--next",
        this.currentSlide === this.counter ? "micado-ial-slider__nav--disabled" : ""
      ].join(" "), onClick: () => this.handleNavigateNext() }, h("micado-svg-icon", { src: "/img/icons/arrow-right.svg" }))))), this.showBullets && this.renderPagination()));
  }
};
MicadoIalSlider.style = micadoIalSliderCss;

const MicadoIalTracking = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.content = null;
    this.onIntersection = async (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const element = this.el.closest("micado-ial-overlay") || this.el.closest("micado-ial-wrapper");
          element.dispatchEvent(new CustomEvent("intersect", { detail: this.identifier }));
        }
        if (entry.isIntersecting &&
          getCookie(`mw-ial-event-view-${this.identifier}`) !== "true") {
          setCookie(`mw-ial-event-view-${this.identifier}`, true);
          track(this.identifier, "view", this.path);
        }
      });
    };
  }
  componentDidLoad() {
    this.observe();
    this.trackLinks();
  }
  observe() {
    this.observer = new IntersectionObserver(this.onIntersection, {
      threshold: 0.25
    });
    this.observer.observe(this.el.querySelector(".micado-ial-item"));
  }
  trackLinks() {
    const links = this.el.querySelectorAll("a, button");
    links.forEach((link) => {
      link.addEventListener("click", () => {
        track(this.identifier, "cta", this.path);
      });
    });
  }
  render() {
    return h(Fragment, null, this.content);
  }
  get el() { return getElement(this); }
};

const micadoIalWrapperCss = ".micado-ial__inner{margin:0 auto;max-width:var(--mco-max-width, var(--mw-max-width, 1280px))}.micado-ial__close{align-items:center;background:var(--mco-palette-gray-100, var(--mw-color-primary-opacity-high, #f2f2f2));border-radius:50%;cursor:pointer;display:flex;height:40px;justify-content:center;position:absolute;right:16px;top:16px;transition:background 300ms ease;width:40px;z-index:99999}.micado-ial__close .micado-svg-icon svg{transition:fill 300ms ease;width:16px}.micado-ial__close:hover{background:var(--mco-palette-secondary-main, var(--mw-color-secondary, #21262d))}.micado-ial__close:hover .micado-svg-icon svg{fill:#ffffff}.micado-ial__notification .micado-ial__close{background:var(--mco-palette-gray-100, var(--mw-color-primary-opacity-high, #f2f2f2));top:50%;transform:translate(0, -50%)}.micado-ial__notification .micado-ial__close:hover{background:var(--mco-palette-secondary-main, var(--mw-color-secondary, #21262d))}.micado-ial__notification .micado-ial__close:hover .micado-svg-icon svg{fill:#ffffff}.micado-ial__countdown .micado-ial__close,.micado-ial__image .micado-ial__close,.micado-ial__message .micado-ial__close,.micado-ial__newsletterregistration .micado-ial__close,.micado-ial__offer .micado-ial__close{background:var(--mco-palette-gray-100, var(--mw-color-primary-opacity-high, #f2f2f2))}.micado-ial__countdown .micado-ial__close:hover,.micado-ial__image .micado-ial__close:hover,.micado-ial__message .micado-ial__close:hover,.micado-ial__newsletterregistration .micado-ial__close:hover,.micado-ial__offer .micado-ial__close:hover{background:var(--mco-palette-secondary-main, var(--mw-color-secondary, #21262d))}.micado-ial__countdown .micado-ial__close:hover .micado-svg-icon svg,.micado-ial__image .micado-ial__close:hover .micado-svg-icon svg,.micado-ial__message .micado-ial__close:hover .micado-svg-icon svg,.micado-ial__newsletterregistration .micado-ial__close:hover .micado-svg-icon svg,.micado-ial__offer .micado-ial__close:hover .micado-svg-icon svg{fill:#ffffff}.micado-ial__bottom{align-items:center;background:var(--mco-palette-primary-main, var(--mw-color-primary, #21262d));bottom:0;display:none;justify-content:center;left:0;position:fixed;right:0;transform:translate(0, 100%);transition:var(--mco-transition, var(--mw-core-transition-overlay, all 500ms cubic-bezier(0.14, 1, 0.67, 0.99)));z-index:99997}.micado-ial__bottom--show{display:block}.micado-ial__bottom--animate{transform:translate(0, 0)}.micado-ial__bottom .micado-ial__close{background:none;top:50%;transform:translate(0, -50%)}.micado-ial__bottom .micado-ial__close .micado-svg-icon svg{fill:#ffffff}.micado-ial__bottom .micado-ial-slider__nav .micado-svg-icon svg{fill:#ffffff}.micado-ial__focus{bottom:0;display:none;left:0;opacity:0;overflow:auto;padding:24px;position:fixed;right:0;top:0;transition:var(--mco-transition, var(--mw-core-transition-overlay, all 500ms cubic-bezier(0.14, 1, 0.67, 0.99)));z-index:99999}.micado-ial__focus::before{background:var(--mco-palette-background-backdrop, var(--mw-color-fancybox-rgba, rgba(30, 30, 30, 0.8)));bottom:0;content:\"\";left:0;opacity:0.9;position:fixed;right:0;top:0;z-index:99997}.micado-ial__focus--show{display:block}.micado-ial__focus--animate{opacity:1}.micado-ial__left{background:var(--mco-palette-background-body, var(--mw-color-body-background, #ffffff));box-shadow:0 0 4px -1px rgba(0, 0, 0, 0.4);display:none;flex-direction:column;max-width:500px;left:0;position:fixed;top:50%;transform:translate(-100%, -50%);transition:var(--mco-transition, var(--mw-core-transition-overlay, all 500ms cubic-bezier(0.14, 1, 0.67, 0.99)));z-index:99998}.micado-ial__left--show{display:block}.micado-ial__left--animate{transform:translate(0, -50%)}.micado-ial__right{background:var(--mco-palette-background-body, var(--mw-color-body-background, #ffffff));box-shadow:0 0 4px -1px rgba(0, 0, 0, 0.4);display:none;flex-direction:column;max-width:500px;position:fixed;right:0;top:50%;transform:translate(100%, -50%);transition:var(--mco-transition, var(--mw-core-transition-overlay, all 500ms cubic-bezier(0.14, 1, 0.67, 0.99)));z-index:99998}.micado-ial__right--show{display:block}.micado-ial__right--animate{transform:translate(0, -50%)}.micado-ial__top{align-items:center;background:var(--mco-palette-primary-main, var(--mw-color-primary, #21262d));display:none;justify-content:center;left:0;position:fixed;right:0;top:0;transform:translate(0, -100%);transition:var(--mco-transition, var(--mw-core-transition-overlay, all 500ms cubic-bezier(0.14, 1, 0.67, 0.99)));z-index:99997}.micado-ial__top--show{display:block}.micado-ial__top--animate{transform:translate(0, 0)}.micado-ial__top .micado-ial__close{background:none;top:50%;transform:translate(0, -50%)}.micado-ial__top .micado-ial__close .micado-svg-icon svg{fill:#ffffff}.micado-ial__top .micado-ial-slider__nav .micado-svg-icon svg{fill:#ffffff}.micado-ial__bottom .micado-ial__inner,.micado-ial__top .micado-ial__inner{padding-right:50px}@media all and (min-width: 1900px){.micado-ial__bottom .micado-ial__inner,.micado-ial__top .micado-ial__inner{padding-right:0}}";

const MicadoIalWrapper = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.close = createEvent(this, "close", 7);
    this.content = null;
    this.data = null;
    this.position = "";
    this.animate = false;
    this.show = false;
    this._timer = null;
  }
  componentDidLoad() {
    this.init();
    this.el.addEventListener("intersect", (event) => {
      var _a;
      this.active = (_a = event === null || event === void 0 ? void 0 : event.detail) !== null && _a !== void 0 ? _a : 0;
    });
  }
  init() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    if (checkShowType((_a = this.data) === null || _a === void 0 ? void 0 : _a.ID, (_b = this.data) === null || _b === void 0 ? void 0 : _b.ShowType) !== "") {
      return;
    }
    switch ((_c = this.data) === null || _c === void 0 ? void 0 : _c.TriggerType) {
      case "PageDepth":
        if (checkPageDepth((_d = this.data) === null || _d === void 0 ? void 0 : _d.ID, (_e = this.data) === null || _e === void 0 ? void 0 : _e.TriggerOption)) {
          this.show = true;
          this._timer = delay_1(() => {
            if (this.position === "top") {
              this.handleNotificationIALTop();
              document.body.classList.add("micado-ial__top--fixed");
            }
            this.animate = true;
          }, 100);
        }
        break;
      case "Scroll":
        const scrollTop = window.scrollY;
        document.addEventListener("scroll", debounce_1(() => {
          const scrollY = window.scrollY;
          if (scrollY - scrollTop > 200) {
            this.show = true;
            this._timer = delay_1(() => {
              if (this.position === "top") {
                this.handleNotificationIALTop();
                document.body.classList.add("micado-ial__top--fixed");
              }
              this.animate = true;
            }, 100);
          }
        }, 100));
        break;
      case "Usertime":
        if (((_f = this.data) === null || _f === void 0 ? void 0 : _f.TriggerOption2) === 0) {
          this.data.TriggerOption2 = 0.05;
        }
        this._timer = delay_1(() => {
          this.show = true;
          this.clearTimer();
          this._timer = delay_1(() => {
            var _a, _b;
            if (this.position === "top") {
              this.handleNotificationIALTop();
              document.body.classList.add("micado-ial__top--fixed");
            }
            this.animate = true;
            if (((_a = this.data) === null || _a === void 0 ? void 0 : _a.TriggerOption) > 0) {
              this.clearTimer();
              this._timer = delay_1(() => {
                this.handleClose();
              }, ((_b = this.data) === null || _b === void 0 ? void 0 : _b.TriggerOption) * 1000);
            }
          }, 100);
        }, ((_g = this.data) === null || _g === void 0 ? void 0 : _g.TriggerOption2) * 1000);
        break;
      case "Immediate":
        this.data.TriggerOption2 = 1;
        this._timer = delay_1(() => {
          this.show = true;
          this.clearTimer();
          this._timer = delay_1(() => {
            if (this.position === "top") {
              this.handleNotificationIALTop();
              document.body.classList.add("micado-ial__top--fixed");
            }
            this.animate = true;
          }, 100);
        }, ((_h = this.data) === null || _h === void 0 ? void 0 : _h.TriggerOption2) * 1000);
        break;
      case "ExitIntention":
        document.addEventListener("mouseleave", () => {
          this.show = true;
          this._timer = delay_1(() => {
            if (this.position === "top") {
              this.handleNotificationIALTop();
              document.body.classList.add("micado-ial__top--fixed");
            }
            this.animate = true;
          }, 100);
        });
        break;
    }
    {
      setShowType((_j = this.data) === null || _j === void 0 ? void 0 : _j.ID, (_k = this.data) === null || _k === void 0 ? void 0 : _k.ShowType, (_l = this.data) === null || _l === void 0 ? void 0 : _l.ShowInterval);
    }
  }
  handleClose() {
    if (this.active) {
      track(this.active, "close", this.path);
    }
    this.clearTimer();
    this.close.emit(this.position);
  }
  handleNotificationIALTop() {
    const $ial = this.el.querySelector(".micado-ial");
    const $header = document.querySelector("header");
    if (!$header)
      return;
    const headerZIndex = parseInt(getComputedStyle($header).zIndex);
    $ial.style.zIndex = headerZIndex ? `${headerZIndex - 1}` : `1`;
    this.checkScroll($ial, $header);
    document.addEventListener("scroll", () => {
      this.checkScroll($ial, $header);
    });
  }
  checkScroll($ial, $header) {
    if (window.scrollY > 0) {
      $ial.style.transform = `translate(0, -100%)`;
      $ial.style.opacity = "0";
    }
    else {
      setTimeout(() => {
        $ial.style.transform = `translate(0, ${$header.offsetHeight}px)`;
        $ial.style.opacity = "1";
      }, 500);
    }
  }
  clearTimer() {
    clearTimeout(this._timer);
    this._timer = null;
  }
  render() {
    var _a;
    return (h(Fragment, null, this.show && (h("div", { class: [
        `micado-ial micado-ial__${this.position} micado-ial__${(_a = this.data) === null || _a === void 0 ? void 0 : _a.Type.toLocaleLowerCase()}`,
        this.show ? `micado-ial__${this.position}--show` : "",
        this.animate ? `micado-ial__${this.position}--animate` : ""
      ].join(" ") }, h("div", { class: "micado-ial__inner" }, this.content), h("div", { class: "micado-ial__close", onClick: () => this.handleClose() }, h("micado-svg-icon", { src: "/img/icons/close.svg" }))))));
  }
  get el() { return getElement(this); }
};
MicadoIalWrapper.style = micadoIalWrapperCss;

const micadoSvgIconCss = ".micado-svg-icon svg{display:flex;height:auto;width:24px}";

const MicadoSVGIcon = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.fetchSVG = async () => {
      const response = await fetch(this.src);
      if (!response.ok) {
        throw new Error(`An error has occured by loading svg: ${response.status}`);
      }
      const data = await response.text();
      return data;
    };
  }
  componentWillLoad() {
    if (!this.src)
      return;
    this.fetchSVG().then(data => {
      this.svgIcon = data;
      this.renderSVG();
    });
  }
  renderSVG() {
    const doc = new DOMParser().parseFromString(this.svgIcon, 'application/xml');
    this.wrapper.appendChild(doc.documentElement);
  }
  render() {
    return h("div", { class: "micado-svg-icon", ref: element => (this.wrapper = element) });
  }
};
MicadoSVGIcon.style = micadoSvgIconCss;

export { MicadoIal as micado_ial, MicadoIalItemContact as micado_ial_item_contact, MicadoIalItemCountdown as micado_ial_item_countdown, MicadoIalItemGraphic as micado_ial_item_graphic, MicadoIalItemMessage as micado_ial_item_message, MicadoIalItemNewsletter as micado_ial_item_newsletter, MicadoIalItemNotification as micado_ial_item_notification, MicadoIalItemOffer as micado_ial_item_offer, MicadoIalOverlay as micado_ial_overlay, MicadoIalSlider as micado_ial_slider, MicadoIalTracking as micado_ial_tracking, MicadoIalWrapper as micado_ial_wrapper, MicadoSVGIcon as micado_svg_icon };
